import React, { PropsWithChildren, useEffect, useRef } from 'react'

interface InfiniteScrollProps {
  isLoading: boolean
  className?: string
  onBottomScroll: () => Promise<any>
}

const InfiniteScroll = ({
  children,
  isLoading,
  className,
  onBottomScroll
}: PropsWithChildren<InfiniteScrollProps>) => {
  const scrollBottomRef = useRef(null)

  useEffect(() => {
    const currentRef = scrollBottomRef.current

    const observer = new IntersectionObserver(
      async (entries) => {
        if (entries[0].isIntersecting && !isLoading) {
          await onBottomScroll()
        }
      },
      { threshold: 1 }
    )

    if (currentRef) {
      observer.observe(currentRef)
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef)
      }
    }
  }, [scrollBottomRef, onBottomScroll, isLoading])

  return (
    <div className={className}>
      {children}
      <div ref={scrollBottomRef} />
    </div>
  )
}

export default InfiniteScroll
